<lib-page-layout>
  <lib-title-navbar pageHeader (actionOnBack)="clearContext()" title="Użytkownicy"></lib-title-navbar>
  <div class="users-page">
    <div class="users-page__sticky">
      <div class="users-page__section">
        <lib-users-filters></lib-users-filters>
      </div>
    </div>
    <div class="users-page__section users-page__section--list">
      <lib-users-list></lib-users-list>
    </div>
  </div>
</lib-page-layout>
